import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loader from './Loader';

/**
 * HomeRedirect - Handles root path "/" routing based on auth state and user role
 * - If not authenticated: redirects to /login
 * - If authenticated: redirects to role-appropriate dashboard
 */
const HomeRedirect = () => {
  const {
    user,
    isAuthenticated,
    loading,
    isGuardian,
    isContractor,
    getContractorContactId,
    isGuardianManager,
    isGuardianManagerWithMaintenance,
    isClient,
    isSalesWithGuardians
  } = useAuth();

  // Show loader while auth state is being determined
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Loader />
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated - redirect based on role

  // Guardian users → Guardian Dashboard
  if (isGuardian()) {
    return <Navigate to="/guardian-dashboard" replace />;
  }

  // Contractor users → Contractor Calendar
  if (isContractor()) {
    const contractorId = getContractorContactId();
    return <Navigate to={`/contractors/contacts/${contractorId}/calendar`} replace />;
  }

  // Guardian Manager With Maintenance → Properties list (properties-only access)
  if (isGuardianManagerWithMaintenance()) {
    return <Navigate to="/properties" replace />;
  }

  // Guardian Manager users → Guardians list
  if (isGuardianManager()) {
    return <Navigate to="/guardians" replace />;
  }

  // Client users → Dashboard
  if (isClient()) {
    return <Navigate to="/dashboard" replace />;
  }

  // Sales With Guardians users → Sales With Guardians Dashboard
  if (isSalesWithGuardians()) {
    return <Navigate to="/sales-with-guardians-dashboard" replace />;
  }

  // Sales users → Clients page
  if (user && user.role === 'SALES') {
    return <Navigate to="/clients" replace />;
  }

  // Default (Staff, Admin, etc.) → Dashboard
  return <Navigate to="/dashboard" replace />;
};

export default HomeRedirect;
